import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取设备信息
   * @param poiId
   * @returns {*}
   */
  getDeviceStatus(poiId) {
    return axios.post('/apigw/api/get/cabin/list', {
      poiId,
    });
  },
};
